import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Row, Col } from 'react-bootstrap';
import HoursTable from '../../../components/stateless/HoursTable';
import Translation from '../../../components/stateless/Translation';

const propTypes = {
  facility: PropTypes.shape({
    hours: PropTypes.shape({
      office: PropTypes.object,
      access: PropTypes.object,
    }).isRequired,
  }),
};

const defaultProps = {
  facility: undefined,
};

const Hours = ({ facility }) => {
  if (!facility) {
    return false;
  }

  const { hours: { office, access } } = facility;

  const officeHours = <Translation id="widgets.hours.officeHours" defaultMessage="Office Hours" />;
  const accessHours = <Translation id="widgets.hours.accessHours" defaultMessage="Access Hours" />;

  return (
    <Row>
      <Col md={12} sm={6} xs={12}>
        <HoursTable
          title={officeHours}
          note={office.note}
          hours={office.hours}
        />
      </Col>
      <Col md={12} sm={6} xs={12}>
        <HoursTable
          title={accessHours}
          note={access.note}
          hours={access.hours}
        />
      </Col>
    </Row>
  );
};

Hours.propTypes = propTypes;
Hours.defaultProps = defaultProps;

Hours.fragments = {
  facility: gql`
    fragment HoursFacility on Facility {
      hours {
        office {
          note
          hours {
            day
            open
            close
          }
        }
        access {
          note
          hours {
            day
            open
            close
          }
        }
      }
    }
  `,
};

export default Hours;
